import {CheckOutlined, CloseOutlined} from '@ant-design/icons'
import {Switch} from 'antd'
import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {BsShieldLockFill} from "react-icons/bs";
import {renderIf} from "../../../views/Shared";

const FieldDescription = ({children, className, title, description}) => {
    const t = useTranslate()
    return (
        <div className={className}>
            <div className="flex flex-col flex-1">
                {renderIf(
                    title,
                    <div className="font-bold text-base text-color-000 tracking-wider">{t(title)}</div>
                )}
                {renderIf(
                    description,
                    <div className="text-color-300 tracking-wider italic">{t(description)}</div>
                )}
            </div>
            {children}
        </div>
    )
}

export const ToggleField = ({
                                name,
                                title,
                                value,
                                disabled,
                                className,
                                onChange,
                                description,
                                defaultValue,
                                Wrapper = FieldDescription,
                            }) => (
    <Wrapper
        title={title}
        description={description}
        className={classNames(
            'flex items-start justify-start w-full space-x-3',
            className
        )}>
        <Switch
            disabled={disabled}
            onChange={onChange}
            checkedChildren={<CheckOutlined/>}
            unCheckedChildren={<CloseOutlined/>}
            defaultChecked={defaultValue}
            {...(value
                ? {
                    checked: value,
                }
                : {})}
        />
    </Wrapper>
)

export const CustomToggleField = ({
                                      title,
                                      className,
                                      description,
                                      Icon = BsShieldLockFill,
                                      ...props
                                  }) => {

    const t = useTranslate()

    const Wrapper = useMemo(() => {
        return ({children}) => (
            <div className="flex flex-col">
                <div className="w-full flex items-center">
                    <div className="flex flex-1 items-center gap-2">
                        <Icon size={16} className="text-secondary-400"/>
                        <span className="font-bold text-base text-secondary-600">{t(title)}</span>
                    </div>
                    {children}
                </div>
                {renderIf(
                    description,
                    <span className="ml-1 text-sm text-color-400 italic mt-1 leading-snug">
                        {`* ${t(description)}`}
                    </span>
                )}
            </div>
        )
    }, [t, title, description])

    return (
        <div className={className ? className : "p-2 border border-dashed border-secondary rounded-lg"}>
            <ToggleField
                {...props}
                Wrapper={Wrapper}
            />
        </div>
    )
}
